<!-- Header: logo + workspace scope switcher -->
<div class="sui-sidebar-header pt-2 border-b-0">
  <a [routerLink]="['home'] | wsLink" class="flex items-center overflow-hidden pl-2.5 mr-1 h-8">
    @if (showFallbackLogo()) {
      <!-- max-w-none lets the collapsing rail clip the wordmark off, leaving the icon; the anchor's mr-1 keeps that clip edge in the icon↔wordmark gap. -->
      <img src="assets/img/semeris-logo-sidenav.svg" alt="Semeris" class="h-full w-auto max-w-none shrink-0" />
    } @else if (logoUrl(); as logo) {
      <img [src]="logo" alt="Company logo" class="h-full w-auto max-w-full object-contain" (error)="onLogoError()" />
    }
  </a>
  <semeris-workspace-selector
    class="mt-2"
    [workspaces]="availableWorkspaces()"
    [selectedWorkspaceId]="selectedWorkspaceId()"
    [gatewayUnavailable]="workspaceGatewayUnavailable()"
    (workspaceSelected)="onWorkspaceSelected($event)"
  />
</div>

<!-- Navigation -->
<div class="sui-sidebar-body" data-guide-target="sidebar-nav">
  <!-- Dashboard + All Tools -->
  <ul class="sui-menu mb-4">
    <li>
      <a
        [routerLink]="['home'] | wsLink"
        routerLinkActive="sui-menu-active"
        [routerLinkActiveOptions]="{ exact: true }"
        [suiTooltip]="isCollapsed() ? 'Dashboard' : null"
        suiTooltipPlacement="right"
      >
        <i class="sui-icon sui-icon-squares-four"></i>
        <span class="flex-1">Dashboard</span>
      </a>
    </li>
    <li>
      <a
        routerLink="/all-tools"
        routerLinkActive="sui-menu-active"
        data-guide-target="sidebar-all-tools"
        [suiTooltip]="isCollapsed() ? 'All Tools' : null"
        suiTooltipPlacement="right"
      >
        <i class="sui-icon sui-icon-compass"></i>
        <span class="flex-1">All Tools</span>
      </a>
    </li>
  </ul>

  <!-- Grouped sections -->
  @for (group of menuGroups(); track group.title) {
    <ng-container *ngTemplateOutlet="groupTpl; context: { $implicit: group }" />
  }
</div>

<!-- Footer — User Guide is permanent, so the divider always has content under it. -->
<div class="sui-sidebar-footer">
  @if (activeUnlistedTool(); as tool) {
    <!-- Current page, when it isn't pinned: transient entry so the sidebar always shows where you are. -->
    <ul class="sui-menu">
      <li>
        <a
          class="group"
          [routerLink]="tool.link | wsLink"
          [queryParams]="tool.extras?.queryParams"
          routerLinkActive="sui-menu-active"
          [suiTooltip]="isCollapsed() ? tool.name : null"
          suiTooltipPlacement="right"
        >
          @if (tool.icon) {
            <i class="sui-icon sui-icon-{{ tool.icon }}"></i>
          }
          <span class="flex-1 truncate">{{ tool.name }}</span>
          <button
            type="button"
            class="shrink-0 p-0.5 rounded transition-all group-hover:opacity-100 focus-visible:opacity-100 hover:text-primary-500"
            [class.text-primary-500]="isPinned(tool.name)"
            [class.text-muted]="!isPinned(tool.name)"
            [class.opacity-0]="!isPinned(tool.name)"
            (click)="togglePin(tool.name, $event)"
            [suiTooltip]="isPinned(tool.name) ? 'Unpin from sidebar' : 'Pin to sidebar'"
            suiTooltipPlacement="top"
          >
            <i class="sui-icon sui-icon-star" [class.sui-icon-fill]="isPinned(tool.name)"></i>
          </button>
        </a>
      </li>
    </ul>
    <div class="border-t border-border my-1"></div>
  }

  <!-- Not a pinnable tool: tenant-scoped, ungated, and the one entry a blocked user still needs. -->
  <ul class="sui-menu">
    <li>
      <a
        [routerLink]="userGuideLink"
        [class.sui-menu-active]="onHelpPage()"
        [suiTooltip]="isCollapsed() ? 'User Guide' : null"
        suiTooltipPlacement="right"
      >
        <i class="sui-icon sui-icon-question"></i>
        <span class="flex-1">User Guide</span>
      </a>
    </li>
  </ul>
</div>

<!-- Group template -->
<ng-template #groupTpl let-group>
  <ul class="sui-menu mb-4">
    <li class="sui-menu-title">{{ group.title }}</li>
    @for (item of group.items; track item.name) {
      <li>
        <a
          [routerLink]="item.link | wsLink"
          [queryParams]="item.extras?.queryParams"
          [class.sui-menu-active]="item.name === activeToolName()"
          [suiTooltip]="isCollapsed() && item.icon ? item.name : null"
          suiTooltipPlacement="right"
        >
          @if (item.icon) {
            <i class="sui-icon sui-icon-{{ item.icon }}"></i>
          }
          <span class="flex-1">{{ item.name }}</span>
        </a>
      </li>
    }
  </ul>
</ng-template>
